// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#amexSrc_reviewContainer {
    min-height: 80%;
    padding: 15px;
}

.fr {
    float: right;
}

.avoid-clicks {
    pointer-events: none;
    cursor: progress;
}

.amex-cart {
    text-align: center;
    height: 45px;
    font-size: 25px;
    background-color: #404040;
    padding: 0.5em;
}

.data-title {
    font-size: 15px !important;
    font-weight: bold !important;
    font-family: Roboto !important;
}

.success {
    color: darkgreen;
}

.fail {
    color: darkred;
}

@media screen and (min-width: 481px) {
    .frame-pos {
        height: 668px;
        width: 375px;
        display: block;
        visibility: visible;
    }
}

@media screen and (max-width: 480px) {
    .frame-pos {
        height: 100%;
        width: 100%;
        display: block;
        visibility: visible;
    }
}

#overlay-div {
    z-index: 1000;
    position: absolute;
    background-color: rgba(0, 0, 0, .75);
    height: 100%;
    width: 100%;
    text-align: center;
    color: white;
}

.overlay-inner-div {
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.fixed-footer {
    background-color: lightgray;
    position: sticky;
    left: 0;
    bottom: 0;
    width: 100%;
    /* border: 0px; */
    height: 3vh;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 0.8em;
}

.checkout-text {
    font-weight: bold;
    position: relative;
    top: -4px;
}

.settings-div {
    position: fixed;
    bottom: 50px;
    right: 50px;
}

@media only screen and (max-width: 500px) {
    #shopping-container, #payload-container {
        padding-right: 15px;
        padding-left: 15px;
        margin-right: 10px;
        margin-left: 10px;
    }
}

@media only screen and (min-width: 501px) {
    #shopping-container, #payload-container {
        padding-right: 15px;
        padding-left: 15px;
        margin-right: 100px;
        margin-left: 100px;
    }
}

.hr-line {
    border: 1px solid #000000;
    margin-top: 10px;
}

.flex-items {
    display: flex !important;
    justify-content: space-between;
    align-items: center;
}

.charge-label {
    font-size: 25px;
    color: #53565A;
    font-weight: 500;
}

.charge-label-2 {
    font-size: 30px;
    color: #53565A;
    font-weight: 500;
}

.settings-container {
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
}

.settings-inner {
    border-top: 1px solid black;
}

.nav-vertical {
    width: 30% !important;
    padding: 0px !important;
}

.config-vertical-hr {
    height: 100%;
    width: 4px;
    background-color: #D86E1F;
    float: right;
}

.flex-center {
    align-items: center;
    justify-content: space-between;
    display: flex;
}

.setting-title {
    font-family: Avenir-Heavy;
    font-size: 20px;
    color: #4A4A4A;
    letter-spacing: 7.36px;
    padding: 22px 27px;
}

.current-setting {
    background-color: #ecedee;
    color: #D86E1F !important;
}

.dcfFrame {
    height: 100vh !important;
}

.src-btn {
    border-radius: 40px !important;
    background-color: #333333 !important;
    width: 250px !important;
    height: 40px !important;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin: auto;
    display: flex;
    padding: 0px 20px !important;
}

.src-btn-text {
    color: white;
    font-weight: bolder;
    font-size: 15px;
}

.nav-link {
    text-decoration: none !important;
    font-size: 18px;
    font-weight: bold;
    line-height: 40px;
    color: #333333;
}

.nav-body {
    font-family: Avenir-Book;
    font-size: 15px;
    color: #4A4A4A;
    line-height: 23px;
    font-weight: 700;
}

.custom-btn {
    color: black !important;
    background: #fff !important;
    border-color: black !important;
    font-weight: bold !important;
}

.custom-btn:hover {
    color: white !important;
    background: #EB8336 !important;
    border-color: black !important;
    font-weight: bold !important;
    opacity: 1 !important;
}

.buy_bt {
    font-size: 16px;
    color: #D86E1F;
    text-align: center;
    margin: 0px;
    font-weight: bold;
}

.jsoneditor {
    border: thin solid #EB8336 !important;
}

.jsoneditor-menu {
    border: thin solid #EB8336 !important;
    background-color: #EB8336 !important;
}

.checkbox input[type=checkbox]:checked + label:before {
    background-color: #EB8336;
    border-color: #EB8336;
}

.amex-card-icon {
    width: 27px;
    height: 27px;
}

.checkbox label {
    margin: 10px;
}

.btn-block:focus-visible {
    outline: 1px dashed #53565A;
    outline-offset: 3px;
}

.btns:focus-visible {
    outline: 1px dashed #53565A;
    outline-offset: 3px;
}

.btn-wrap:focus-visible {
    outline: 1px dashed #53565A;
    outline-offset: 3px;
}

.btn-secondary:focus-visible,
.cancel-btn:focus-visible,
.btn-fluid:focus-visible {
    outline: 1px dashed #53565A;
    outline-offset: 3px;
}

a:focus-visible {
    outline: 1px dashed #53565A !important;
    outline-offset: 1px;
}

.btn-fluid:focus-visible, .radio:focus-visible  {
    outline: 1px dashed #53565A;
    outline-offset: 3px;
}

.error-header {
    font-weight: 400;
    line-height: 1.3;
    margin: 0.68em 0;
    padding: 0;
    font-size: 2.15em;
}

.header-1 {
    font-weight: 400;
    font-size: 2.15em;
}

.alert.alert-info {
    padding: 15px;
    margin-bottom: 20px;
    border: 1px solid transparent;
    background-color: #f5f5f5;
    border-color: #8b8d8f;
    color: #363636;
    margin-top: 30px;
    display: flex;
    flex-direction: column;
}

p.info {
    position: relative;
    font-size: 15px;
    margin-bottom: 10px;
}

.stage {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    position: relative;
    padding: 2rem 0;
    margin: 0 -5%;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type=number] {
    -moz-appearance: textfield; /* Firefox */
}

.cancel-btn {
    height: 30px;
    border: 1px solid;
    border-radius: 30px;
    width: 300px;
}

.cancel-btn:hover {
    background: #E9E9E9;
}
`, "",{"version":3,"sources":["webpack://./src/client/App.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;QACb,YAAY;QACZ,cAAc;QACd,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;QACX,cAAc;QACd,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,oCAAoC;IACpC,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,OAAO;IACP,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;AAEA;IACI;QACI,mBAAmB;QACnB,kBAAkB;QAClB,kBAAkB;QAClB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,kBAAkB;QAClB,mBAAmB;QACnB,kBAAkB;IACtB;AACJ;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,8BAA8B;IAC9B,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,8BAA8B;IAC9B,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;;;IAGI,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,aAAa;AACjB;;AAEA;;IAEI,8CAA8C;IAC9C,wBAAwB;IACxB,SAAS,EAAE,uEAAuE;AACtF;;AAEA;IACI,0BAA0B,EAAE,YAAY;AAC5C;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["#amexSrc_reviewContainer {\n    min-height: 80%;\n    padding: 15px;\n}\n\n.fr {\n    float: right;\n}\n\n.avoid-clicks {\n    pointer-events: none;\n    cursor: progress;\n}\n\n.amex-cart {\n    text-align: center;\n    height: 45px;\n    font-size: 25px;\n    background-color: #404040;\n    padding: 0.5em;\n}\n\n.data-title {\n    font-size: 15px !important;\n    font-weight: bold !important;\n    font-family: Roboto !important;\n}\n\n.success {\n    color: darkgreen;\n}\n\n.fail {\n    color: darkred;\n}\n\n@media screen and (min-width: 481px) {\n    .frame-pos {\n        height: 668px;\n        width: 375px;\n        display: block;\n        visibility: visible;\n    }\n}\n\n@media screen and (max-width: 480px) {\n    .frame-pos {\n        height: 100%;\n        width: 100%;\n        display: block;\n        visibility: visible;\n    }\n}\n\n#overlay-div {\n    z-index: 1000;\n    position: absolute;\n    background-color: rgba(0, 0, 0, .75);\n    height: 100%;\n    width: 100%;\n    text-align: center;\n    color: white;\n}\n\n.overlay-inner-div {\n    position: absolute;\n    top: 60%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.fixed-footer {\n    background-color: lightgray;\n    position: sticky;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    /* border: 0px; */\n    height: 3vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n    font-size: 0.8em;\n}\n\n.checkout-text {\n    font-weight: bold;\n    position: relative;\n    top: -4px;\n}\n\n.settings-div {\n    position: fixed;\n    bottom: 50px;\n    right: 50px;\n}\n\n@media only screen and (max-width: 500px) {\n    #shopping-container, #payload-container {\n        padding-right: 15px;\n        padding-left: 15px;\n        margin-right: 10px;\n        margin-left: 10px;\n    }\n}\n\n@media only screen and (min-width: 501px) {\n    #shopping-container, #payload-container {\n        padding-right: 15px;\n        padding-left: 15px;\n        margin-right: 100px;\n        margin-left: 100px;\n    }\n}\n\n.hr-line {\n    border: 1px solid #000000;\n    margin-top: 10px;\n}\n\n.flex-items {\n    display: flex !important;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.charge-label {\n    font-size: 25px;\n    color: #53565A;\n    font-weight: 500;\n}\n\n.charge-label-2 {\n    font-size: 30px;\n    color: #53565A;\n    font-weight: 500;\n}\n\n.settings-container {\n    padding-right: 15px;\n    padding-left: 15px;\n    margin-right: auto;\n    margin-left: auto;\n}\n\n.settings-inner {\n    border-top: 1px solid black;\n}\n\n.nav-vertical {\n    width: 30% !important;\n    padding: 0px !important;\n}\n\n.config-vertical-hr {\n    height: 100%;\n    width: 4px;\n    background-color: #D86E1F;\n    float: right;\n}\n\n.flex-center {\n    align-items: center;\n    justify-content: space-between;\n    display: flex;\n}\n\n.setting-title {\n    font-family: Avenir-Heavy;\n    font-size: 20px;\n    color: #4A4A4A;\n    letter-spacing: 7.36px;\n    padding: 22px 27px;\n}\n\n.current-setting {\n    background-color: #ecedee;\n    color: #D86E1F !important;\n}\n\n.dcfFrame {\n    height: 100vh !important;\n}\n\n.src-btn {\n    border-radius: 40px !important;\n    background-color: #333333 !important;\n    width: 250px !important;\n    height: 40px !important;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    margin: auto;\n    display: flex;\n    padding: 0px 20px !important;\n}\n\n.src-btn-text {\n    color: white;\n    font-weight: bolder;\n    font-size: 15px;\n}\n\n.nav-link {\n    text-decoration: none !important;\n    font-size: 18px;\n    font-weight: bold;\n    line-height: 40px;\n    color: #333333;\n}\n\n.nav-body {\n    font-family: Avenir-Book;\n    font-size: 15px;\n    color: #4A4A4A;\n    line-height: 23px;\n    font-weight: 700;\n}\n\n.custom-btn {\n    color: black !important;\n    background: #fff !important;\n    border-color: black !important;\n    font-weight: bold !important;\n}\n\n.custom-btn:hover {\n    color: white !important;\n    background: #EB8336 !important;\n    border-color: black !important;\n    font-weight: bold !important;\n    opacity: 1 !important;\n}\n\n.buy_bt {\n    font-size: 16px;\n    color: #D86E1F;\n    text-align: center;\n    margin: 0px;\n    font-weight: bold;\n}\n\n.jsoneditor {\n    border: thin solid #EB8336 !important;\n}\n\n.jsoneditor-menu {\n    border: thin solid #EB8336 !important;\n    background-color: #EB8336 !important;\n}\n\n.checkbox input[type=checkbox]:checked + label:before {\n    background-color: #EB8336;\n    border-color: #EB8336;\n}\n\n.amex-card-icon {\n    width: 27px;\n    height: 27px;\n}\n\n.checkbox label {\n    margin: 10px;\n}\n\n.btn-block:focus-visible {\n    outline: 1px dashed #53565A;\n    outline-offset: 3px;\n}\n\n.btns:focus-visible {\n    outline: 1px dashed #53565A;\n    outline-offset: 3px;\n}\n\n.btn-wrap:focus-visible {\n    outline: 1px dashed #53565A;\n    outline-offset: 3px;\n}\n\n.btn-secondary:focus-visible,\n.cancel-btn:focus-visible,\n.btn-fluid:focus-visible {\n    outline: 1px dashed #53565A;\n    outline-offset: 3px;\n}\n\na:focus-visible {\n    outline: 1px dashed #53565A !important;\n    outline-offset: 1px;\n}\n\n.btn-fluid:focus-visible, .radio:focus-visible  {\n    outline: 1px dashed #53565A;\n    outline-offset: 3px;\n}\n\n.error-header {\n    font-weight: 400;\n    line-height: 1.3;\n    margin: 0.68em 0;\n    padding: 0;\n    font-size: 2.15em;\n}\n\n.header-1 {\n    font-weight: 400;\n    font-size: 2.15em;\n}\n\n.alert.alert-info {\n    padding: 15px;\n    margin-bottom: 20px;\n    border: 1px solid transparent;\n    background-color: #f5f5f5;\n    border-color: #8b8d8f;\n    color: #363636;\n    margin-top: 30px;\n    display: flex;\n    flex-direction: column;\n}\n\np.info {\n    position: relative;\n    font-size: 15px;\n    margin-bottom: 10px;\n}\n\n.stage {\n    display: flex;\n    justify-content: center;\n    align-items: flex-end;\n    position: relative;\n    padding: 2rem 0;\n    margin: 0 -5%;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    /* display: none; <- Crashes Chrome on hover */\n    -webkit-appearance: none;\n    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */\n}\n\ninput[type=number] {\n    -moz-appearance: textfield; /* Firefox */\n}\n\n.cancel-btn {\n    height: 30px;\n    border: 1px solid;\n    border-radius: 30px;\n    width: 300px;\n}\n\n.cancel-btn:hover {\n    background: #E9E9E9;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
